<div class="ds-grid ds-grid--3">
	<!-- Primary Switch with checkedValue/uncheckedValue -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Primary Switch</h3>
			<p class="ds-example__header-subtitle">With checkedValue / uncheckedValue (Enabled/Disabled)</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-switch
				[label]="'Enable feature'"
				[checkedValue]="'Enabled'"
				[uncheckedValue]="'Disabled'"
				(switchChange)="onSwitchChange('Primary', $event)">
			</eif-custom-switch>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value">
				<div class="ds-value__label">Value:</div>
				<div class="ds-value__content">{{ primaryValue || 'No value' }}</div>
			</div>
		</div>
	</div>

	<!-- Success Switch -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Success Switch</h3>
			<p class="ds-example__header-subtitle">With icon and checkedValue/uncheckedValue</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-switch
				[label]="'Confirm action'"
				[color]="'success'"
				[icon]="'fa-solid fa-check'"
				[checkedValue]="'Active'"
				[uncheckedValue]="'Inactive'"
				(switchChange)="onSwitchChange('Success', $event)">
			</eif-custom-switch>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value ds-value--success">
				<div class="ds-value__label">Value:</div>
				<div class="ds-value__content">{{ successValue || 'No value' }}</div>
			</div>
		</div>
	</div>

	<!-- Info Switch with tooltip -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Info Switch</h3>
			<p class="ds-example__header-subtitle">With icon and tooltip</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-switch
				[label]="'Enable notifications'"
				[color]="'info'"
				[icon]="'fa-solid fa-info-circle'"
				[tooltip]="'Receive email notifications'"
				[checkedValue]="'On'"
				[uncheckedValue]="'Off'"
				(switchChange)="onSwitchChange('Info', $event)">
			</eif-custom-switch>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value ds-value--info">
				<div class="ds-value__label">Value:</div>
				<div class="ds-value__content">{{ infoValue || 'No value' }}</div>
			</div>
		</div>
	</div>

	<!-- Warning Switch -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Warning Switch</h3>
			<p class="ds-example__header-subtitle">With checkedValue/uncheckedValue</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-switch
				[label]="'Proceed with caution'"
				[color]="'warning'"
				[icon]="'fa-solid fa-exclamation-triangle'"
				[checkedValue]="'Proceed'"
				[uncheckedValue]="'Cancel'"
				(switchChange)="onSwitchChange('Warning', $event)">
			</eif-custom-switch>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value ds-value--warning">
				<div class="ds-value__label">Value:</div>
				<div class="ds-value__content">{{ warningValue || 'No value' }}</div>
			</div>
		</div>
	</div>

	<!-- Danger Switch -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Danger Switch</h3>
			<p class="ds-example__header-subtitle">With icon support</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-switch
				[label]="'Delete permanently'"
				[color]="'danger'"
				[icon]="'fa-solid fa-trash'"
				[checkedValue]="'Delete'"
				[uncheckedValue]="'Keep'"
				(switchChange)="onSwitchChange('Danger', $event)">
			</eif-custom-switch>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value ds-value--danger">
				<div class="ds-value__label">Value:</div>
				<div class="ds-value__content">{{ dangerValue || 'No value' }}</div>
			</div>
		</div>
	</div>

	<!-- Disabled Switch -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Disabled Switch</h3>
			<p class="ds-example__header-subtitle">Non-interactive state</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-switch
				[label]="'Cannot be changed'"
				[color]="'neutral'"
				[icon]="'fa-solid fa-ban'"
				[checkedValue]="'Active'"
				[disabled]="true"
				(switchChange)="onSwitchChange('Disabled', $event)">
			</eif-custom-switch>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value ds-value--disabled">
				<div class="ds-value__label">Value:</div>
				<div class="ds-value__content">{{ disabledValue || 'No value' }}</div>
			</div>
		</div>
	</div>

	<!-- ngModel binding -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">ngModel Binding</h3>
			<p class="ds-example__header-subtitle">Two-way data binding</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-switch
				[label]="'Toggle with ngModel'"
				[(ngModel)]="ngModelValue"
				(switchChange)="onSwitchChange('NgModel', $event)">
			</eif-custom-switch>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value">
				<div class="ds-value__label">Value:</div>
				<div class="ds-value__content">{{ ngModelValue }}</div>
			</div>
		</div>
	</div>

	<!-- Projected content (label + description on same row) -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Projected Content</h3>
			<p class="ds-example__header-subtitle">Label above, description inline with switch</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-switch
				[label]="'Resource translation'"
				[(ngModel)]="projectedContentValue"
				(switchChange)="onSwitchChange('Projected', $event)">
				Turn resource translation on or off
			</eif-custom-switch>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value">
				<div class="ds-value__label">Value:</div>
				<div class="ds-value__content">{{ projectedContentValue }}</div>
			</div>
		</div>
	</div>

	<!-- Validation rules & error state -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Validation Rules</h3>
			<p class="ds-example__header-subtitle">Required rule with validationChange and error display</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-switch
				#validationSwitch
				[label]="'Accept terms to continue'"
				[checkedValue]="'Accepted'"
				[uncheckedValue]="'Not accepted'"
				[validationRules]="requiredSwitchRules"
				(validationChange)="onValidationChange($event)">
			</eif-custom-switch>
			<eif-custom-button
				[text]="'Validate'"
				[type]="'button'"
				[size]="'small'"
				[class]="'mt-2'"
				[preIcon]="'fa-solid fa-check'"
				(action)="validationSwitch.validate()">
			</eif-custom-button>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value">
				<div class="ds-value__label">Valid:</div>
				<div class="ds-value__content">{{ validationValid ? 'Yes' : 'No' }}</div>
			</div>
		</div>
	</div>
</div>
